module.exports = __webpack_public_path__ + "files/769af362a6223e9471f1e7f23dc371c2.png";